export enum EKiliFilterType {
  ID = "ID",
  STRING = "STRING",
  PATH = "PATH",
  DROPDOWN_BY_ID = "DROPDOWN_BY_ID",
}

export enum EKiliIdFilterOperator {
  EQUALS = "EQUALS",
  NOT_EQUALS = "NOT_EQUALS",
}

export enum EKiliPathFilterOperator {
  CONTAINS_IGNORE_CASE = "CONTAINS_IGNORE_CASE",
  BEGINS_WITH_IGNORE_CASE = "BEGINS_WITH_IGNORE_CASE",
}

export enum EKiliStringFilterOperator {
  CONTAINS_IGNORE_CASE = "CONTAINS_IGNORE_CASE",
  BEGINS_WITH_IGNORE_CASE = "BEGINS_WITH_IGNORE_CASE",
}

interface TKiliFilterDefinition<T> {
  type: EKiliFilterType;
  operators: { [K in keyof T]: string };
  defaultOperator: T[keyof T];
}

export const KiliIdFilter: TKiliFilterDefinition<typeof EKiliIdFilterOperator> = {
  get type() {
    return EKiliFilterType.ID;
  },
  get operators() {
    return EKiliIdFilterOperator;
  },
  get defaultOperator() {
    return EKiliIdFilterOperator.EQUALS;
  },
};

export const KiliPathFilter: TKiliFilterDefinition<typeof EKiliPathFilterOperator> = {
  get type() {
    return EKiliFilterType.PATH;
  },
  get operators() {
    return EKiliPathFilterOperator;
  },
  get defaultOperator() {
    return EKiliPathFilterOperator.CONTAINS_IGNORE_CASE;
  },
};

export const KiliStringFilter: TKiliFilterDefinition<typeof EKiliStringFilterOperator> = {
  get type() {
    return EKiliFilterType.STRING;
  },
  get operators() {
    return EKiliStringFilterOperator;
  },
  get defaultOperator() {
    return EKiliStringFilterOperator.CONTAINS_IGNORE_CASE;
  },
};

export const KiliDropdownFilter: TKiliFilterDefinition<typeof EKiliIdFilterOperator> = {
  get type() {
    return EKiliFilterType.DROPDOWN_BY_ID;
  },
  get operators() {
    return EKiliIdFilterOperator;
  },
  get defaultOperator() {
    return EKiliIdFilterOperator.EQUALS;
  },
};

export type TKiliFilterType =
  | typeof KiliIdFilter
  | typeof KiliPathFilter
  | typeof KiliStringFilter
  | typeof KiliDropdownFilter;
